import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import Payin from 'PMT/entities/Payin';

import CurrencyUtils from 'PMT/utils/CurrencyUtils';

export default class PayinsTableViewRowDetail extends Component {

  static propTypes = {
    payin: PropTypes.objectOf(Payin),
    currencyCode: PropTypes.string,
  };

  render(): Object {
    const payin:Payin = this.props.payin;
    const currencyCode: string = this.props.currencyCode;

    return (
      <tr className="payins_table_view_row_detail">
        <td>{payin.getFormattedDate()}</td>
        <td>{payin.getFormattedHour()}</td>
        <td className="text-right"><span className="empty"> - </span></td>
        <td className="text-right">
          {CurrencyUtils.formatPriceWithCurrency(payin.amount + payin.tips,
              currencyCode)}
        </td>

        <td className="text-right">
          {payin.tips > 0 &&
              (<span>{CurrencyUtils.formatPriceWithCurrency(payin.tips,
                  currencyCode)}</span>)
          }
          {payin.tips === 0 &&
            (<span className="empty"> - </span>)
          }
        </td>

        <td></td>

      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/payment/receipt/components/PayinsTableViewRowDetail.js